import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const roles = auth.currentUser()?.roles.map(role => role.name) ?? [];

  return roles.includes('admin') || roles.includes('super_admin')
    ? true
    : router.createUrlTree(['/home/inicio']);
};
